import React, { useState, useEffect } from "react"
import { Container, Row, Col, Card, CardBody } from "reactstrap"
import { URLS } from "../../Url"
import axios from "axios"
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts"

const Dashboard = () => {
  const GetAuth = localStorage.getItem("authUser")
  const TokenJson = JSON.parse(GetAuth)
  const TokenData = TokenJson.token

  const [MonthlyOrders, setMonthlyOrders] = useState([])

  useEffect(() => {
    getDashboardData()
  }, [])

  const getDashboardData = () => {
    const token = TokenData
    axios
      .post(
        URLS.GetDashboard,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setMonthlyOrders(res?.data?.monthlyresult || [])
      })
      .catch(error => {
        console.error("Error fetching dashboard data:", error)
      })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="mb-3">
            <Row>
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <h2 className="font-semibold mb-2">Monthly Orders</h2>
                    <ResponsiveContainer width="100%" height={300}>
                      <LineChart data={MonthlyOrders}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="date" />
                        <YAxis />
                        <Tooltip />
                        <Line
                          type="monotone"
                          dataKey="sales"
                          stroke="#0088FE"
                          strokeWidth={2}
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Dashboard
